import React, { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import Grid from './Grid';

const ActiveAdvanceReceivables = () => {

  const location = useLocation();

  const makeMenuItemActive = useCallback(() => {
    document.querySelector('#menuitem-accounts').click();
    document
      .querySelector('#kt_header_tab_4 > div > div > ul > li:nth-child(1)')
      .classList.add('menu-item-active');
    document
      .querySelector('#kt_header_tab_4 > div > div > ul > li:nth-child(3)')
      .classList.remove('menu-item-active');
  }, [location.pathname]);

  useEffect(() => {
    makeMenuItemActive();
  }, [makeMenuItemActive]);

  return (
    <div className="container mt-10 mb-10" style={{ maxWidth: "95%" }}>
      <div className="row">
        <div className="col-md-12 bg-white box-shadow-border">
          <div style={{ padding: "0.5rem" }}>
            <div className="d-flex mt-5 mb-10">
              <div className="mr-auto">
                <h1>Active Advance Receivables</h1>
              </div>
            </div>
            <Row>
              <Col md="12"><Grid /></Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveAdvanceReceivables;
